import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { MegaMenu } from '../../components/layout/header/MegaMenu';
import { ScrollToTop } from '../../components/layout/ScrollToTop';

const LayoutStudent = () => {
  const navigate = useNavigate();
  const isActive = localStorage.getItem('isActive');
  useEffect(() => {
    if (isActive === 'false') {
      navigate('/student/first-login');
    }
  }, []);
  return (
    <>
      <MegaMenu />
      <main className="mt-[58px]">
        <ScrollToTop>
          <Outlet />
        </ScrollToTop>
      </main>
    </>
  );
};

export default LayoutStudent;
